import type { EnvironmentConfigurationValues } from "./EnvironmentConfiguration";

const environmentConfigurationValues: EnvironmentConfigurationValues = import.meta.env;

export default environmentConfigurationValues;
